// Google Analytics 4 implementation
declare global {
  interface Window {
    gtag: (...args: any[]) => void;
    dataLayer: any[];
  }
}

// Initialize Google Analytics
export const initGA = (measurementId: string) => {
  // Load the GA script
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  document.head.appendChild(script);

  // Initialize gtag
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag('js', new Date());
  window.gtag('config', measurementId, {
    send_page_view: false, // We'll handle page views manually
  });
};

// Track page views
export const trackPageView = (path: string) => {
  window.gtag('event', 'page_view', {
    page_path: path,
    page_title: document.title,
  });
};

// Track custom events
export const trackEvent = (
  eventName: string,
  eventParams?: Record<string, any>
) => {
  window.gtag('event', eventName, eventParams);
};

// Track affiliate clicks
export const trackAffiliateClick = (firmId: string, firmName: string) => {
  trackEvent('affiliate_click', {
    firm_id: firmId,
    firm_name: firmName,
    timestamp: new Date().toISOString(),
  });
};

// Track newsletter signups
export const trackNewsletterSignup = (source: string) => {
  trackEvent('newsletter_signup', {
    source: source,
    timestamp: new Date().toISOString(),
  });
};

// Track tool usage
export const trackToolUsage = (toolName: string, params?: Record<string, any>) => {
  trackEvent('tool_usage', {
    tool_name: toolName,
    ...params,
    timestamp: new Date().toISOString(),
  });
};

// Track blog interactions
export const trackBlogInteraction = (
  action: 'view' | 'share' | 'comment',
  postSlug: string,
  postTitle: string
) => {
  trackEvent('blog_interaction', {
    action,
    post_slug: postSlug,
    post_title: postTitle,
    timestamp: new Date().toISOString(),
  });
};

// Track review interactions
export const trackReviewInteraction = (
  action: 'view' | 'compare' | 'share',
  firmSlug: string,
  firmName: string
) => {
  trackEvent('review_interaction', {
    action,
    firm_slug: firmSlug,
    firm_name: firmName,
    timestamp: new Date().toISOString(),
  });
};

// Track search queries
export const trackSearch = (query: string, resultsCount: number) => {
  trackEvent('search', {
    query,
    results_count: resultsCount,
    timestamp: new Date().toISOString(),
  });
};

// Track user engagement
export const trackEngagement = (
  type: 'scroll_depth' | 'time_spent' | 'interaction',
  value: number,
  page: string
) => {
  trackEvent('user_engagement', {
    type,
    value,
    page,
    timestamp: new Date().toISOString(),
  });
};

// Track conversion events
export const trackConversion = (
  type: 'signup' | 'purchase' | 'lead',
  value?: number,
  currency?: string
) => {
  trackEvent('conversion', {
    type,
    value,
    currency,
    timestamp: new Date().toISOString(),
  });
}; 